import { __rest } from "tslib";
import React, { forwardRef, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { createReactWrapper } from '../common/PrefixUtils';
import { handleForwardRef } from '../common/RefUtils';
import { addExtraProps } from '../common/utils/AddExtraProps';
export const TooltipV2 = forwardRef((_a, ref) => {
    var { children, trigger, zIndex, onChange } = _a, props = __rest(_a, ["children", "trigger", "zIndex", "onChange"]);
    const tooltipRef = useRef();
    const handledRef = handleForwardRef(tooltipRef, ref);
    const domTarget = useRef(null);
    const [isContentAttachedAndOpened, setIsContentAttachedAndOpened] = useState(false);
    const handleChange = (event) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event.detail.isOpen);
    };
    /**
     * This is called everytime popover is opened and it will always contain a content element in it.
     * @param event
     */
    const handleContentAttached = (event) => {
        setIsContentAttachedAndOpened(event.detail.isAttachedAndOpen);
    };
    useEffect(() => {
        var _a, _b;
        (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('popoverchange', handleChange);
        (_b = tooltipRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('popovercontentattached', handleContentAttached);
        return () => {
            var _a, _b;
            (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('popoverchange', handleChange);
            (_b = tooltipRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('popovercontentattached', handleContentAttached);
        };
    }, [ref, onChange]);
    useEffect(() => {
        var _a, _b;
        /*
          Set the target after the chameleon-popover is loaded so we can have access to chameleon-popover-content.
          This will allow us to use the reactPortal to have events delegated to the proper element once chameleon-popover-content
          moves outside of chameleon-popover
        */
        domTarget.current = ((_b = (_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('chameleon-popover-content')) || null;
    }, [ref]);
    return createReactWrapper({
        tagName: 'chameleon-tooltip-v2',
        props: Object.assign(Object.assign({}, props), { ref: handledRef, 'z-index': zIndex }),
        children: (React.createElement(React.Fragment, null,
            addExtraProps(trigger, { slot: 'trigger' }),
            React.createElement("div", { slot: "content" }, domTarget.current &&
                isContentAttachedAndOpened &&
                createPortal(children, domTarget.current.querySelector('div[slot]'))))),
    });
});
